import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classOverride", "disableEffects", "disableCloseByEscape", "disableOverlay", "isCloseButtonVisible", "isFixed", "wide", "zIndex", "open", "defaultOpen", "onOpenChange", "onClose", "enablePortal", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useRef } from 'react';
import { extendChildrenWithProps, extractContentSections } from './index';
import { sideSheetContent, sideSheetHeaderCloseButtonContainer, sideSheetHeaderContainer } from '../constants';
import { useControlledFlagState } from '../../../system/hooks/useControlledFlagState';
import { useOverlay } from '../../../system/hooks/useOverlay';
import { iconStyle } from '../style';
import { useInternalRef } from '../../../utils';
import { useOuterClick } from '../../../system/hooks/useOuterClick';
import { useDisplayEffects } from '../../../system/hooks/useDisplayEffects';
import { useDocumentKeydown } from '../../../system/hooks/useDocumentKeyDown';
export var useSideSheet = function useSideSheet(_ref, ref, theme) {
  var classOverride = _ref.classOverride,
      disableEffects = _ref.disableEffects,
      disableCloseByEscape = _ref.disableCloseByEscape,
      disableOverlay = _ref.disableOverlay,
      isCloseButtonVisible = _ref.isCloseButtonVisible,
      isFixed = _ref.isFixed,
      wide = _ref.wide,
      zIndex = _ref.zIndex,
      open = _ref.open,
      defaultOpen = _ref.defaultOpen,
      onOpenChange = _ref.onOpenChange,
      onClose = _ref.onClose,
      enablePortal = _ref.enablePortal,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useControlledFlagSta = useControlledFlagState(defaultOpen, open, onOpenChange),
      _useControlledFlagSta2 = _slicedToArray(_useControlledFlagSta, 4),
      reallyOpen = _useControlledFlagSta2[0],
      setClose = _useControlledFlagSta2[3];

  var _useOverlay = useOverlay(reallyOpen, {
    zIndex: zIndex
  }),
      realZIndex = _useOverlay.zIndex,
      isTopOverlay = _useOverlay.isTopOverlay;

  var onCloseInternal = useCallback(function () {
    if (isTopOverlay()) {
      if (onClose) {
        onClose();
      }

      setClose();
    }
  }, [onClose, setClose, isTopOverlay]);
  var rootRef = useRef();
  useInternalRef(ref, rootRef);
  var windowRef = useRef();
  useOuterClick([windowRef], onCloseInternal, reallyOpen && !disableOverlay);

  var _useDisplayEffects = useDisplayEffects(reallyOpen),
      display = _useDisplayEffects.display,
      effectToggle = _useDisplayEffects.effectToggle;

  var childrenWithExtendedProps = extendChildrenWithProps(children, {
    classOverride: classOverride,
    isFixed: isFixed,
    theme: theme
  });
  var onKeyDown = useCallback(function (event) {
    if (disableCloseByEscape || event.key !== 'Escape' || !isTopOverlay()) {
      return;
    }

    onCloseInternal();
  }, [isTopOverlay, onCloseInternal, disableCloseByEscape]);
  useDocumentKeydown(onKeyDown);

  var _extractContentSectio = extractContentSections(childrenWithExtendedProps),
      header = _extractContentSectio.header,
      body = _extractContentSectio.body,
      footer = _extractContentSectio.footer;

  return {
    portalProps: {
      enablePortal: enablePortal
    },
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: rootRef,
      zIndex: realZIndex
    }),
    overlayProps: {
      disableEffects: disableEffects,
      disableOverlay: disableOverlay,
      display: display,
      effectToggle: effectToggle
    },
    windowProps: {
      disableEffects: disableEffects,
      display: display,
      effectToggle: effectToggle,
      wide: wide,
      ref: windowRef
    },
    contentProps: {
      'data-testid': sideSheetContent
    },
    headerContainerProps: {
      'data-testid': sideSheetHeaderContainer
    },
    closeButtonContainerProps: {
      'data-testid': sideSheetHeaderCloseButtonContainer,
      onClick: onCloseInternal
    },
    closeButtonContentProps: {},
    closeButtonIconProps: {
      style: iconStyle,
      tabIndex: 0
    },
    header: header,
    body: body,
    footer: footer,
    isCloseButtonVisible: isCloseButtonVisible,
    wide: wide,
    disableOverlay: disableOverlay,
    theme: theme
  };
};